import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { FeaturedProjects } from '../components/FeaturedProjects';
import { Skills } from '../components/Skills';
import { SqlPlayground } from '../components/SqlPlayground';
import { CaseStudyHighlight } from '../components/CaseStudyHighlight';
import { EducationExperience } from '../components/EducationExperience';
import { GitLog } from '../components/GitLog';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-text">
      <Navbar />
      <Hero />
      <Skills />
      <FeaturedProjects />
      <SqlPlayground />
      <CaseStudyHighlight />
      <EducationExperience />
      <GitLog />
      <CTA />
      <Footer />
    </div>
  );
};

export default HomePage;
